/**
 * Array utility methods
 */

import pick from 'lodash-es/pick';

/**
 * Find the Object with the given key value.
 *
 * @param  {Array}  array   The array we're searching.
 * @param  {string} key     The object key we're looking at.
 * @param  {any}    value   The key value we're looking for.
 * @return {Object}         The Object.
 */
export function findObjectWithKey(array, key, value) {
    if (!Array.isArray(array) || key === undefined || value === undefined) {
        return null;
    }

    return array.find(element => {
        return element[key] === value;
    });
}

/**
 * Find the index of the given key value.
 *
 * @param  {Array} array    The array we're searching.
 * @param  {string} key     The object key we're looking at.
 * @param  {any} value      The key value we're looking for.
 * @return {number|undefined}         The index of the element.
 */
export function findObjectWithKeyIndex(array, key, value) {
    if (!array) {
        return;
    }

    return array.findIndex(element => {
        return element[key] === value;
    });
}

/**
 * Remove an item from an array.
 * @param  {Array} array    The array to remove the item from.
 * @param  {*} element      The item to remove.
 * @return {boolean}        Whether the item was removed.
 */
export function remove(array, element) {
    const index = array.indexOf(element);

    if (index > -1) {
        array.splice(index, 1);
        return true;
    }

    return false;
}

export function except(target, keys: string | string[]) {
    if (!Array.isArray(keys)) {
        keys = [keys];
    }

    if (keys.length === 0) {
        return;
    }

    const originalTarget = target;

    if (!Array.isArray(target)) {
        target = [target];
    }

    const results = [];

    for (const i of target) {
        let object = target[i];

        for (const j in keys) {
            const key = keys[j];
            let parts = key.split('.');

            while (parts.length > 1) {
                const part = parts.shift();

                if (part in object && angular.isObject(object[part])) {
                    object = object[part];
                } else {
                    parts = [];
                }
            }

            delete object[parts.shift()];
        }

        results.push(object);
    }

    return Array.isArray(originalTarget) ? results : results[0];
}

export function only(target: object[] | object, keys: string[]) {
    if (Array.isArray(target)) {
        return target.map(element => pick(element, keys));
    }

    return pick(target, keys);
}

export function flip(array: any[]) {
    let key;
    const result = {};

    for (key in array) {
        result[array[key]] = key;
    }

    return result;
}

export function rotateLeft(array, amount) {
    amount = (amount || 0) % array.length;

    if (amount < 0) {
        amount += array.length;
    }

    const removed = array.splice(0, amount);

    array.push(...removed);

    return array;
}

export function rotateRight(array, amount) {
    if (amount < 0) {
        throw new Error('amount cannot be less than 0');
    }

    return rotateLeft(array, -amount);
}
